import { render, staticRenderFns } from "./pedidosBusqueda.vue?vue&type=template&id=6db53cdc"
import script from "./pedidosBusqueda.vue?vue&type=script&lang=js"
export * from "./pedidosBusqueda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports